import { Stack, Shimmer, Separator } from '@fluentui/react';
import { ShimmerSection3 } from 'approvals/ApprovalDetails/ShimmerView/ShimmerViews';
import { ShimmerSection } from 'notification/view/ShimmerView';
import { ShimmerSection2 } from 'Preferences/ShimmerView';
import { ShimmerSection4 } from 'purchaseOrder/view/FormView/Shimmer/ShimmerViews';
import React from 'react';
import { ShimmerSection5 } from 'settings/account/approvalSetup/view/ShimmerView/ShimmerViews';

import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => {
  return {
    container: {
      display: 'flex',
    },
    fullWidthContainer: { display: 'flex', flexWrap: 'wrap', width: '100%' },
    containerpadding: { padding: '0px 20px 10px' },
    containerMargin: { padding: 20 },
  };
});

export const ShimmerView: React.FC = () => {
  const styles = useStyles();
  return (
    <React.Fragment>
      <Separator />
      <Stack className={styles.containerpadding}>
        <Shimmer customElementsGroup={ShimmerSection4()} />
      </Stack>
      <Stack className={styles.containerpadding}>
        <Shimmer customElementsGroup={ShimmerSection3()} />
      </Stack>
      <Separator />
      <Stack className={styles.containerpadding}>
        <Shimmer customElementsGroup={ShimmerSection4()} />
      </Stack>
      <Stack className={styles.containerpadding}>
        <Shimmer customElementsGroup={ShimmerSection5()} />
      </Stack>
    </React.Fragment>
  );
};
